/** In die Zwischenablage kopieren; ohne HTTPS fehlt navigator.clipboard, dann über ein unsichtbares Textfeld. */
export async function copyText(text: string) {
  if (window.isSecureContext && navigator.clipboard) return navigator.clipboard.writeText(text).then(() => true, () => false);
  const ta = document.createElement("textarea");
  ta.value = text;
  ta.setAttribute("readonly", "");
  ta.style.position = "fixed";
  ta.style.opacity = "0";
  document.body.append(ta);
  ta.select();
  const done = document.execCommand("copy");
  ta.remove();
  return done;
}
